import Component from './component';

const Button = (props) => <Component {...props} />;

export default Button;

export { Component as component };
